import React from "react";
import { Button, Dropdown, Menu } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { NAVBAR_STYLES } from "../../css/styles";
import {
  ACCOUNT_SIGN_IN_ROUTE,
  ADMIN_DASHBOARD_PATH,
  HOME_PAGE_ROUTE,
} from "../../app/api/routeConstants";
import { signOutFirebase } from "../../app/firestore/firebaseService";
import { toast } from "react-toastify";
import { signOutUser } from "../auth/authActions";
import ReactGA from "react-ga4";
import { getUserState } from "../../js/helpers/getSignedInUserType";
import userAvatar from "../../assets/icons/user.svg";
import menuIcon from "../../assets/icons/menu.svg";
import signOutIcon from "../../assets/icons/sign-out.svg";

export default function AccountMenu({ navbar, position = "right" }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { pathname } = useSelector((state) => state.router.location);
  const { authenticated } = useSelector((state) => state.auth);
  const { currentUserAccount } = useSelector((state) => state.account);
  const { isCookieConsent, responsive } = useSelector((state) => state.app);

  async function handleSignOut() {
    if (isCookieConsent) {
      ReactGA.event({
        category: "Metrics",
        action: "User sign-out",
        label: getUserState(currentUserAccount),
      });
    }
    try {
      history.push("/");
      dispatch(signOutUser());
      await signOutFirebase();
    } catch (error) {
      toast.error(error.message);
    }
  }

  function getDisplayName() {
    if (currentUserAccount.displayName && !currentUserAccount.firstName) {
      return currentUserAccount.displayName;
    } else if (
      currentUserAccount.firstName === null ||
      currentUserAccount.displayName === null
    ) {
      return "";
    } else {
      return currentUserAccount.firstName;
    }
  }

  function getSignedInDisplay() {
    if (!responsive.isMobile) {
      return `Hello, ${getDisplayName()}` || "";
    } else {
      return (
        <img
          src={userAvatar}
          style={{ marginRight: 0, height: 20, width: 20 }}
          alt={"user avatar"}
        />
      );
    }
  }

  return (
    <Menu.Menu position={position}>
      {authenticated && currentUserAccount ? (
        <Menu.Item
          position={position}
          style={{
            fontSize: 17,
            fontFamily: "Lato, sans-serif",
            paddingRight: 0,
          }}
        >
          <div
            className={
              pathname === HOME_PAGE_ROUTE &&
              navbar === NAVBAR_STYLES.navbarTransparent
                ? "account-menu-signed-in-transparent-navbar"
                : "account-menu-signed-in"
            }
          >
            <Dropdown
              style={{
                color: "white",
                paddingLeft: responsive.isComputer ? 8 : 2,
                paddingRight: 15,
                fontSize: 16,
                fontFamily: "Lato, sans-serif",
              }}
              trigger={getSignedInDisplay()}
              className="account-menu"
              direction={"left"}
              // className={isOpen ? "account-menu-open" : "account-menu"}
              // open={isOpen}
              // onClick={() => setIsOpen(!isOpen)}
            >
              <Dropdown.Menu style={{ marginTop: 15 }}>
                {currentUserAccount.isAdmin && (
                  <Dropdown.Item
                    value="dashboard"
                    onClick={() => history.push(ADMIN_DASHBOARD_PATH)}
                  >
                    <span className="dropdown-menu-text">
                      <img className="menu-icon" src={menuIcon} alt="menu" />
                      Dashboard
                    </span>
                  </Dropdown.Item>
                )}
                <Dropdown.Item onClick={handleSignOut}>
                  <span className="dropdown-menu-text">
                    <img
                      className="menu-icon"
                      src={signOutIcon}
                      alt="user avatar"
                    />
                    Sign out
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Menu.Item>
      ) : (
        <Menu.Item>
          <Button
            className="overwrite-button orange-inverse-button orange-transparent-inverse-button"
            content={<div className={"main-text"}>Sign in</div>}
            onClick={() => history.push(ACCOUNT_SIGN_IN_ROUTE)}
            style={{ margin: "0 18px 0 0" }}
          />
          {/* {!responsive.isMobile && (
            <Button
              className="overwrite-button cta-orange"
              content={<div className={"main-text"}>Create account</div>}
              onClick={() => dispatch(openModal({ modalType: SIGN_UP_MODAL }))}
            />
          )} */}
        </Menu.Item>
      )}
    </Menu.Menu>
  );
}
